import { render, staticRenderFns } from "./InquiryExpired.vue?vue&type=template&id=6f79f101"
import script from "./InquiryExpired.vue?vue&type=script&lang=js"
export * from "./InquiryExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports